import { LevelEntity } from '../../../../../shared/LevelTypes';

export interface TeleporterLink {
  targetId?: string;
  targetMapId?: string;
  conditions?: {
    minLevel?: number;
    requiredQuest?: string;
    requiredItem?: string;
  };
}

export interface TeleporterData {
  entity: LevelEntity;
  link?: TeleporterLink;
  collidesWithProjectiles?: boolean;
  isSelected: boolean;
}

export const AVAILABLE_QUESTS = [
  { id: 'tutorial_complete', name: 'Tutorial Complete' },
  { id: 'first_mob_kill', name: 'First Blood' },
  { id: 'reach_level_10', name: 'Novice Adventurer' },
];

export const AVAILABLE_ITEMS = [
  { id: 'portal_key_basic', name: 'Basic Portal Key' },
  { id: 'portal_key_gold', name: 'Golden Portal Key' },
];

export function hexToRgb(hex: string): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ?
    `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` :
    '128, 128, 128';
}
